import './../common/base';
import Vue from './common/vue-common';
import DiscountsPage from './components/discount/DiscountsPage';

cr$.ready(() => new Vue(DiscountsPage));
